<script>
	// import { LottiePlayer } from '@lottiefiles/svelte-lottie-player';
	import { onMount } from 'svelte';
    
	// @ts-ignore
	let LottiePlayer;
	onMount(async () => {
		const module = await import('@lottiefiles/svelte-lottie-player');
		LottiePlayer = module.LottiePlayer;
	});
</script>

{#if LottiePlayer}
	<LottiePlayer
		src="/assets/lottie/sending-letter.json"
		autoplay={true}
		loop={true}
		controls={false}
		renderer="svg"
		background="transparent"
		width={300}
        height={300}
	/>
{/if}
